import styled from "styled-components";
import { COLORS, FONT_SIZE } from "../../../constants/Styles";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 1rem 0 2rem;

  > button {
    padding-left: 0.75rem;
  }
`;

export const BoardsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
`;

export const NoBoards = styled.div`
  > div {
    margin-bottom: 2rem;
  }
`;

export const FiltersContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 1rem;
  flex-direction: column;
`;

export const SectionContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 1rem;
  align-items: center;
`;

export const FiltersRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.75rem;

  > img {
    margin-right: 0.5rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${COLORS.black};
  padding: 0.25rem;
  height: 40px;
  border-radius: 100px;
  justify-content: space-between;
`;

export const SortingOption = styled.div<{ isSelected: boolean }>`
  color: ${COLORS.secondaryLight};
  cursor: pointer;
  padding: 0.5rem 1rem;
  font-size: ${FONT_SIZE.size14};

  ${({ isSelected }) =>
    isSelected &&
    `
      color: ${COLORS.secondary};
      background-color: ${COLORS.inputGray};
      border-radius: 100px;
      cursor: default;
  `}
`;
